module.exports = __webpack_public_path__ + "static/kakuro3-d1b139dd58ca4db679349458e2b5dbd0.png";